import React from 'react'
import { connect } from 'react-redux'

// Interpreta un valor como UTC. Robusto ante cadenas sin marca de zona (sin Z ni ±hh:mm):
// se tratan como UTC en vez de como hora local del navegador.
const toUtc = (value) => {
  if (value instanceof Date) return value
  if (typeof value === 'string') {
    const hasTz = /[zZ]|[+-]\d{2}:?\d{2}$/.test(value)
    if (!hasTz && /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(value)) {
      return new Date(value.replace(' ', 'T') + 'Z')
    }
  }
  return new Date(value)
}

// detectedAt / createdAt se guardan en UTC real -> se muestran en hora de Madrid (UTC+2 en
// verano). Sin el toUtc, un valor sin Z se mostraba tal cual (parecía UTC).
const fmtMadrid = (value) => {
  if (!value) return ''
  return toUtc(value).toLocaleString('es-ES', { timeZone: 'Europe/Madrid' })
}

// TimeStamp de la venta = hora de pantalla del kiosco (ya en hora local): se muestra tal cual,
// sin reconvertir, igual que SaleList en la vista de Ventas (misma venta, misma hora).
const fmtStamp = (value) => {
  if (!value) return ''
  return new Date(value).toLocaleString('es-ES', { timeZone: 'UTC' })
}

const fmtEur = (value) => {
  const n = parseFloat(value)
  if (isNaN(n)) return ''
  return n.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })
}

const openInNewTab = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

class DuplicatedSaleList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentPage: 1,
      todosPerPage: 100,
    }

    this.onPrevClick = this.onPrevClick.bind(this)
    this.onNextClick = this.onNextClick.bind(this)
  }

  onPrevClick() {
    this.setState((s) => ({ currentPage: Math.max(1, s.currentPage - 1) }))
  }

  onNextClick(totalPages) {
    this.setState((s) => ({ currentPage: Math.min(totalPages, s.currentPage + 1) }))
  }

  render() {
    // La vista pasa ya la lista filtrada (p. ej. sin VACWAY); si no, se lee del store.
    const list = this.props.sales ||
      (this.props.duplicatedSales && this.props.duplicatedSales.duplicatedSales) || []
    const { currentPage, todosPerPage } = this.state

    if (list.length === 0) {
      return (
        <div className="dup-empty">
          <i className="fas fa-check-circle"></i>
          No hay ventas duplicadas en este rango.
        </div>
      )
    }

    const totalPages = Math.ceil(list.length / todosPerPage) || 1
    const page = Math.min(currentPage, totalPages)
    const indexOfLast = page * todosPerPage
    const indexOfFirst = indexOfLast - todosPerPage
    const current = list.slice(indexOfFirst, indexOfLast)

    const renderRows = current.map((sale, index) => {
      const lost = sale.SameAsOriginal === false
      return (
        <tr key={sale._id || index}>
          <th scope="row">{sale.Code}</th>
          <td>{(sale.Customer && sale.Customer.Fullname) || '—'}</td>
          <td>{(sale.Machine && sale.Machine.Serial) || '—'}</td>
          <td>{fmtEur(sale.Amount)}</td>
          <td>{fmtStamp(sale.TimeStamp)}</td>
          <td>{fmtMadrid(sale.detectedAt || sale.createdAt)}</td>
          <td>
            <span className={`dup-badge ${lost ? 'dup-badge--lost' : 'dup-badge--replica'}`}>
              {lost ? 'Venta perdida' : 'Réplica'}
            </span>
          </td>
          <td>
            {sale.OriginalSaleId ? (
              <button
                className="dup-collision-btn"
                title="Ver la venta original con la que chocó el Code"
                onClick={() => openInNewTab(`/sales/${sale.OriginalSaleId}`)}
              >
                {fmtStamp(sale.OriginalTimeStamp)} · {fmtEur(sale.OriginalAmount)}
                <i className="fas fa-external-link-alt"></i>
              </button>
            ) : '—'}
          </td>
        </tr>
      )
    })

    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Factura</th>
              <th scope="col">Cliente</th>
              <th scope="col">Máquina</th>
              <th scope="col">Importe</th>
              <th scope="col">Fecha Compra</th>
              <th scope="col">Detectado</th>
              <th scope="col">Tipo</th>
              <th scope="col">Colisiona con</th>
            </tr>
          </thead>
          <tbody>
            {renderRows}
          </tbody>
        </table>
        {totalPages > 1 && (
          <div className="dup-pagination">
            <button className="btn btn-sm btn-outline-primary" onClick={this.onPrevClick} disabled={page === 1}>
              <i className="fas fa-chevron-left mr-1"></i>Anterior
            </button>
            <span className="dup-page-info">Página {page} de {totalPages}</span>
            <button className="btn btn-sm btn-outline-primary" onClick={() => this.onNextClick(totalPages)} disabled={page === totalPages}>
              Siguiente<i className="fas fa-chevron-right ml-1"></i>
            </button>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  duplicatedSales: state.duplicatedSales,
  role: state.auth.role,
})

export default connect(mapStateToProps)(DuplicatedSaleList)
